<template>
  <vx-card no-shadow v-if="showWindow">
    <h3>Transactions</h3>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>id</vs-th>
                <vs-th>wallet</vs-th>
                <vs-th>tran_type</vs-th>
                <vs-th>created_at</vs-th>
                <vs-th>status_name</vs-th>
                <vs-th>payment_method</vs-th>
                <vs-th>value_approved</vs-th>
                <vs-th>amount_approved</vs-th>
                <vs-th>single_tran_threshold</vs-th>
                <vs-th>month_tran_threshold</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].id">
                        {{data[indextr].id}}
                    </vs-td>
                    <vs-td :data="data[indextr].wallet">
                        {{data[indextr].wallet}}
                    </vs-td>
                    <vs-td :data="data[indextr].tran_type">
                        {{data[indextr].tran_type}}
                    </vs-td>
                    <vs-td :data="data[indextr].created_at">
                        {{data[indextr].created_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].status_name">
                        {{data[indextr].status_name}}
                    </vs-td>
                    <vs-td :data="data[indextr].payment_method">
                        {{data[indextr].payment_method}}
                    </vs-td>
                    <vs-td :data="data[indextr].value_approved">
                        {{data[indextr].value_approved}}
                    </vs-td>
                    <vs-td :data="data[indextr].amount_approved">
                        {{data[indextr].amount_approved}}
                    </vs-td>
                    <vs-td :data="data[indextr].single_tran_threshold">
                        {{data[indextr].single_tran_threshold}}
                    </vs-td><vs-td :data="data[indextr].month_tran_threshold">
                        {{data[indextr].month_tran_threshold}}
                    </vs-td>                
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      popupActive: false,
      params: {},
      saleStatus:saleStatus,
      tableData:[]
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-transactions');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData = response.data;
      })
      .catch((error) => { console.log('error',error) })
    },
  }
}
</script>
